import { useFormContext } from '@ariakit/react'
import { useCallback, useContext } from 'react'

import { VariantSelectionFormContext } from '../../../../../app/_components/forms/VariantSelectionForm'
import { useVariantSelectionSizeField } from '../../../../../app/_components/forms/VariantSelectionSizeField'

/**
 * The modal's add to bag on a PDP. It submits the variant selection form, so the bag line is the one
 * the page's own add to bag builds: the form's quantity, the page's portal and team store details,
 * and the same validation. Must be called inside the variant selection form.
 */
export const useDtcEmbroideryAddToBag = () => {
  const { selectedVariant } = useContext(VariantSelectionFormContext)!
  const { value: size } = useVariantSelectionSizeField()
  const form = useFormContext()

  const isDisabled = !size || !selectedVariant || selectedVariant.availability !== 'AVAILABLE'
  const productPriceInCents = selectedVariant
    ? Math.round(selectedVariant.price.amount * 100)
    : undefined

  /** Runs `confirm` and submits the form, or does neither when there is nothing to add yet. */
  const addToBag = useCallback(
    (confirm: () => void) => {
      if (isDisabled || !form) return
      confirm()
      form.submit()
    },
    [form, isDisabled]
  )

  return { addToBag, isDisabled, productPriceInCents }
}
